import React from 'react';
import PropTypes from 'prop-types';
import {getUrlWithSize} from '../../utils/urls';

class AnnouncementCardSlider extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      currentIndex: 0
    };

    this.photos = this.props.photos
        .map((photo, idx) => getUrlWithSize(photo.get('url'), idx === 0 ? 'large' : this.props.photoSize));

    this.photosCount = this.photos.size;
    this.lastIndex = this.photosCount - 1;

    this.prevPhoto = this.prevPhoto.bind(this);
    this.nextPhoto = this.nextPhoto.bind(this);
  }

  nextPhoto (e) {
    e.preventDefault();
    const index = this.state.currentIndex;
    const nextIndex = index < this.lastIndex ? index + 1 : 0;

    this.setState({ currentIndex: nextIndex });
  }

  prevPhoto (e) {
    e.preventDefault();
    const index = this.state.currentIndex;
    const prevIndex = index > 0 ? index - 1 : this.lastIndex;

    this.setState({ currentIndex: prevIndex });
  }

  /**
   * Грузить только текущий/предыдущий и следующий слайды
   * @param index текущий индекс
   */
  beDownloaded (index) {
    const currentIndex = this.state.currentIndex;

    // загружаем последннее фото если стоим на первом фото
    if (index === this.lastIndex && currentIndex === 0) {
      return true;
    }

    // загружаем текущий + следующий
    return index <= currentIndex + 1;
  }

  renderImages () {
    return this.photos.map((url, index) =>
      <div
        className='photo-item'
        key={index}
      >
        <img src={url} />
      </div>
    );
  }

  render () {
    if (!this.photosCount) {
      return null;
    }

    return (
      <div className={this.props.className}>
        <div className='photo-list'>
          {this.renderImages()}

          {this.photosCount > 1 && ([
            <button className='arrow icon-arrow-left-new' onClick={this.prevPhoto} key='left' />,
            <button className='arrow icon-arrow-right-new' onClick={this.nextPhoto} key='right' />
          ])}

          {
            this.photosCount &&
            this.props.showPhotoCount &&
            <div className='counter'>{(this.state.currentIndex + 1) + ' из ' + this.photosCount}</div>
          }
        </div>
      </div>
    );
  }
}

AnnouncementCardSlider.propTypes = {
  photos: PropTypes.object.isRequired,
  photoSize: PropTypes.string.isRequired,
  showPhotoCount: PropTypes.bool,
  className: PropTypes.string
};

AnnouncementCardSlider.defaultProps = {
  photos: [],
  className: 'announcement-card-slider'
};

export default AnnouncementCardSlider;



// WEBPACK FOOTER //
// ./src/ui/Sliders/AnnouncementCardSlider.jsx